import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IfBrowserDirective } from '@df/ui/common/if-browser.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../../../../../../ui/api/action.component';
import { ResultComponent } from '../../../../../../ui/api/result.component';
import { ProductListingAddToBasketButtonComponent } from './product-listing-add-to-basket-button.component';

@Component({
    selector: 'product-listing-add-to-basket-button-exp',
    templateUrl: './product-listing-add-to-basket-button-exp.component.html',
    styleUrl: './product-listing-add-to-basket-button-exp.component.scss',
    standalone: true,
    imports: [ActionComponent, CommonModule, IfBrowserDirective, ResultComponent, TranslatePipe, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListingAddToBasketButtonExpComponent extends ProductListingAddToBasketButtonComponent {}
